import { IDropdownItem } from '@sanlam-glacier/app-common/components';
import { InvestmentModelMock } from '../types/client.interfaces';
import { ControllerRenderProps } from 'react-hook-form';
import { StatementFormValues } from '../types/client.types';
import { StatementTypes } from '../types/client.enum';

export const AssistiveTextBasedOnStatementType: Record<StatementTypes, string> = {
  [StatementTypes.transactionSummary]: 'Select one or more investments.',
  [StatementTypes.transactionDetail]:
    'Only one investment can be selected for a transaction detail statement.',
  [StatementTypes.fundDetail]: 'Only one investment can be selected for a fund detail statement.',
  [StatementTypes.internalRateOfReturnInv]: 'Select one or more investments.'
};

export const filterInvestmentsBySelectedNames = (
  items: string | IDropdownItem | (string | IDropdownItem)[],
  investments: InvestmentModelMock[]
): InvestmentModelMock[] => {
  const selectedInvestmentNames = items as string[];
  return investments.filter((inv) => selectedInvestmentNames.includes(inv.investmentName));
};

export const handleStatementPeriodToggle = (
  val: string,
  item: string,
  field: ControllerRenderProps<StatementFormValues, 'statementPeriodType'>
) => {
  let current: string[] = [];
  if (field.value !== null) current = field.value as string[];

  if (val === 'checked') {
    if (!current.includes(item)) {
      field.onChange([...current, item]);
    }
  } else {
    field.onChange(current.filter((i: string) => i !== item));
  }
};

export const handleStatementOptionsToggle = (
  val: string,
  item: string,
  field: ControllerRenderProps<StatementFormValues, 'statementOptions'>
) => {
  const current = field.value ?? [];
  if (val === 'checked') {
    if (!current.includes(item)) {
      field.onChange([...current, item]);
    }
  } else {
    field.onChange(current.filter((i) => i !== item));
  }
};


// The order of the dates matter, endDate must be larger than startDate
export const validateDate = (startDate: Date, endDate: Date) => {
  const msInDay = 1000 * 60 * 60 * 24;
  const diffInMs = endDate.getTime() - startDate.getTime();
  const diffInDays = diffInMs / msInDay;
  return diffInDays >= 30;
};
